import React, { useContext } from "react";
import MatomoContext from "../core/matomo.context";
var useMatomo = function () {
    var instance = useContext(MatomoContext);
    var trackPageView = React.useCallback(function (documentTitle) { return instance === null || instance === void 0 ? void 0 : instance.trackPageView(documentTitle); }, []);
    var trackEvent = React.useCallback(function (args) { return instance === null || instance === void 0 ? void 0 : instance.trackEvent(args); }, []);
    return { trackPageView: trackPageView, trackEvent: trackEvent };
};
export default useMatomo;
